import React from 'react'
import { Link, Typography } from '@mui/material'
import { Person as PersonIcon } from '@mui/icons-material'
import { handleLightspeedLinkClick } from '../../utils/externalLinks'
import { CustomerData, formatClientName } from '../../utils/inspectorFormatters'

interface ClientLinkCellProps extends CustomerData {
  lightspeed_customer_link?: string
  showIcon?: boolean
  iconSize?: number
}

/**
 * Displays a client name as a clickable link that opens their sales history in Lightspeed.
 * Falls back to plain text if no link is available.
 *
 * @param props - Client data including optional Lightspeed link
 * @returns Client name as link or plain text
 */
const ClientLinkCell: React.FC<ClientLinkCellProps> = ({
  customer_id,
  customer_first_name,
  customer_last_name,
  customer_company,
  lightspeed_customer_link,
  showIcon = false,
  iconSize = 16
}) => {
  const clientName = formatClientName({
    customer_id,
    customer_first_name,
    customer_last_name,
    customer_company
  })

  if (!lightspeed_customer_link) {
    return (
      <Typography variant="body2">
        {clientName}
      </Typography>
    )
  }

  return (
    <>
      {showIcon && <PersonIcon sx={{ fontSize: iconSize, mr: 0.5, verticalAlign: 'middle', color: 'primary.main' }} />}
      <Link
        href={lightspeed_customer_link}
        onClick={(e) => handleLightspeedLinkClick(
          e,
          lightspeed_customer_link,
          `Client Sales - ${clientName}`
        )}
        sx={{
          textDecoration: 'none',
          color: 'inherit',
          '&:hover': {
            textDecoration: 'underline',
            color: 'primary.main'
          }
        }}
      >
        {clientName}
      </Link>
    </>
  )
}

export default ClientLinkCell